import { validate, v4 } from "uuid"
import { Brand } from "./helpers"

export type Uuid = Brand<string, "Uuid">

export function createUuid(): Uuid {
  return v4() as Uuid
}

export function assertUuid(uuid: unknown): asserts uuid is Uuid {
  if (typeof uuid !== "string" || !validate(uuid)) {
    throw Error(`Invalid UUID: ${uuid}`)
  }
}

export function assertUuidOrNull(uuid: unknown): asserts uuid is Uuid | null {
  if (uuid !== null) {
    assertUuid(uuid)
  }
}
